"use strict";
/**
 * Created by eritru on 2015-02-16.
 */

var idMap;
var table_batiment;
var table_evenement;
var table_communication;
var table_document;
var explorateur_selection_carte_layers = window.explorateur_selection_carte_layers = [];


$(function () {
    $('body').tooltip({
        selector: '[data-toggle="tooltip"]'
    });
});

function ExplorateurUEchargeTableauEvenement() {
    //Charge le tableau évènement
    var dateEvenement = moment().format('YYYY-MM-DD');
    var params = {};
    params.id_ue = $('#exp-ue-body-information').find('#id-ue').text();
    params.id_municipalite = $('#exp-ue-liste-ville').val();
    params.callback_fermeture_modal = function () {
        // TODO: à supprimer si possible
        destroyDataTable(table);
        expUegetEvenementUe(params, dateEvenement);
    };

    if (params.id_ue) {
        wait.start();
        expUegetEvenementUe(params, dateEvenement);
        wait.stop();
    } else {
        destroyDataTable(table_evenement);
        $('#exp-ue-body-evenement').empty().append(getBanniereMessage('', "Sélectionner une unité d'évaluation"));
    }

}
function expAssignerEvenementInitTableEvenement(autreCallback, listeIdEvenementSelection){
    controlesFormulaires.redimentionnerTextarea();
    var unitesEvaluation = $('#div-resultat-historique').find('.list-group-item');
    unitesEvaluation = unitesEvaluation.filter(":visible");
    var listeIdUe = [];

    $.each(unitesEvaluation, function (idx, value) {
        var idUe = $(value).attr('id-ue');
        if (idUe != '') listeIdUe.push(idUe);
        // if (idUe != '') listeIdUeDateEvenement.push({id_ue:idUe, dateEvenementComplet:dateEvenementComplet});
    });
    var layerlistediv = $('#div-resultat-layer').find('[name="hid-filtres-layer"]');
    var layerliste = [];
    layerlistediv.each(function () {
        var idMapLayer = $(this).val();
        layerliste.push(idMapLayer);
    });

    var listeIdUeDateEvenement = [];
    if ($('#listeUe').val() != ''){
        listeIdUeDateEvenement = JSON.parse($('#listeUe').val());
    }
    tableAssignerEvenement(listeIdUe, layerliste, listeIdUeDateEvenement, autreCallback, listeIdEvenementSelection);
}

function init_explorateur_ue_1() {
    explorateur_selection_carte_layers = [];
    $('#modal-recherche').detach().appendTo('body');

    $('#modal-recherche').attr('recharger', 'oui');
    init_explorateur_ue_partage();

    var id_mun_initial = $('#idMunicipaliteStartup').val();
    if (!id_mun_initial) id_mun_initial = $('#id_municipalite_init').val();
    $('#exp-ue-liste-ville').select2();
    if (id_mun_initial && id_mun_initial !== '00000') {
        if (est_nouvel_onglet) {
            id_mun_initial = $('#id_municipalite_init').val();
            if (id_mun_initial) {
                $('#exp-ue-liste-ville').select2('val', id_mun_initial);
            }
        } else {
            $("#exp-ue-liste-ville").val(id_mun_initial).trigger('change');
        }
    }
    $('#exp-ue-langue').select2();
    $('#exp-ue-auto-decl-mode').select2();

    $('#nav-search-input').off('input').on('input', function () {
        $('#div-resultat-historique a').show();
        $('#div-resultat-historique a').not('*:contains("' + $(this).val().toUpperCase() + '")').closest('a').hide();
    });

    if ($('#exp-ue-id-matricule').length > 0) {
        IMask($('#exp-ue-id-matricule')[0], {
            mask: '0000-00-0000-000-0000',
        });
    }

    // Ouvre la page de recherche
    $('#exp-ue-btn-ouvrir-recherche').off('click').on('click', function () {
        $('body').css('margin-right', '0px'); //PATCH POUR STOPPER LE MOUVEMENT DE LA PAGE VERS LA DROITE À L'OUVERTURE DU MODAL

        $('#modal-message-background').remove();
        $('.modal-backdrop:first').not('.stacked').addClass('stacked');

        // reset valeurs champ dynamique dépendant municipalité
        $('#exp-ue-no-dossier-ancien').val('');
        $('#no_dossier_ancien_div').hide();

        $('#modal-recherche').modal({
            show: true,
            backdrop: 'static'
        });
        var idxModal = ($('.modal:visible').length - 1);
        $('.modal-backdrop').not('.stacked').css('z-index', 9000 + (10 * idxModal) - 1);
        // Pour les ouvertures dans des modals, on déplace ces modals vers le body du document html
        //$('#modal-recherche').detach().appendTo('body');
        fenetreModal.calculerHauteurModal($('#main-container'));

        // 10106
        var idMunicipalite;
        if ($('#exp-ue-liste-ville').val() === '') {
            idMunicipalite = '00000';
        } else {
            idMunicipalite = $('#exp-ue-liste-ville').val();
        }
        initExpUeProprietaireSelect2(idMunicipalite);

        var nomMunicipalite = $("#exp-ue-liste-ville option:selected").text();
        $('#exp-ue-titre-mun').text(nomMunicipalite);


        ouvrirRechercheExpUe(idMunicipalite);

    });

    //Permet de charger la map avec la ville sélectionnée
    var selectMunicipalite = $('#exp-ue-liste-ville');
    selectMunicipalite.off('change').on('change', function () {
        if ($(this).val() === '') return;

        // On force le chargement des voies publiques lorsque l'utilisateur change de municipalité
        $('#modal-recherche').attr('recharger', 'oui');
        $('#modal-recherche').attr('recharger', 'oui');
        expUegetInfoUeAddMap();

        $('#exp-ue-vider-histo').prop("disabled", false);
        $('#exp-ue-toggle-histo').prop("disabled", false);
        $('#exp-ue-btn-ouvrir-recherche').prop("disabled", false);
        $('#btn-tenue-a-jour-modal-creer-evenement').prop("disabled", false);

        idMunicipalite = $(this).val();
        var nomMunicipalite = $("#exp-ue-liste-ville option:selected").text();
        $('#exp-ue-titre-mun').text(nomMunicipalite);

        //17875
        idMap = getInfoMap(idMunicipalite, 31);

        //Obtenir les cycles pour laquelle on a une matrice graphique dépend du champs maj_sig
        getBboxMunicipalite(idMunicipalite, function (bbox) {
            myBbox = bbox;

            if (bbox.DateDonneesGerflo != null) {
                $('#date-donnees-gerflo').text("Données provenant de GeRFLo en date du : " + bbox.DateDonneesGerflo);
            } else {
                $('#date-donnees-gerflo').text("");
            }
            //17875
            expUeinitMap(idMunicipalite, bbox, true, idMap);

        });

        cleanExplorateurUe();

        // lors d'un changement de municipalite on reinitialise les voies publiques
        $('#voie-publique').find('option').remove().end();
        $('#voie-publique').append('<option value=""></option>');

        $('#no-civique').find('option').remove().end();
        $('#no-civique').append('<option value=""></option>');

        $('#exp-ue-vider').trigger('click', ['non']);

    });

    $('#exp-ue-vider-histo').off('click').on('click', function (e) {
        effacerfiltrelayer();
        var divResultatHistorique = $('#div-resultat-historique');

        divResultatHistorique.find('.list-group-item').each(function (i) {
            var matricule = $(this).attr('id-matricule');
            enleverSelectionCarte(map, matricule);
        });

        $('#div-resultat-historique').empty();
        $('#listeUe').val('');

        $('#btn-generer-pdf').prop('disabled', true);
        $('#btn-exp-assigner-evenement').prop('disabled', true);

        $('#div-resultat-historique-nb').text('0');

    });
    // Permet d'envoyer vers le bas l'historique de recherche
    $('#exp-ue-toggle-histo').off('click').on('click', function (e) {
        if ($(e.target).hasClass('active')) {
            $('#exp-ue-information').removeClass('col-md-pull-2 col-md-10');
            $('#exp-ue-information').addClass('col-md-12');
            $('#exp-ue-historique').css('display', 'none');
        } else {
            $('#exp-ue-information').removeClass('col-md-12');
            $('#exp-ue-information').addClass('col-md-pull-2 col-md-10');
            $('#exp-ue-historique').css('display', 'block');
        }
        if (map != null) {
            map.invalidateSize();
        }
        ($(e.target).hasClass('active')) ? $(e.target).removeClass('actif') : $(e.target).addClass('actif');
        ($(e.target).hasClass('active')) ? $(this).find('i').removeClass('fa-rotate-180') : $(this).find('i').addClass('fa-rotate-180');
    });

    $('#btn-tenue-a-jour-modal-creer-evenement').off('click').on('click', function () {

        var dateEvenement = moment().format('YYYY-MM-DD');
        var params = {};
        params.id_municipalite = $('#exp-ue-liste-ville').val();
        if ($('#id-ue') && $('#id-ue').text()) {
            params.id_ue = $('#id-ue').text();
            params.callback_fermeture_modal = function () {
                expUegetEvenementUe(params, dateEvenement); // On met  à jour la liste des évènements.
                expUegetPhotoPrincipale(dateEvenement, $('#id-ue').text());// On met à jour le lien de la photo de l'explorateur pour pointer sur le nouvel évènement créé.
                destroyDataTable(table_batiment);
                $('#exp-ue-body-batiment').empty();
                expUegetBatimentUe($('#id-ue').text(), $('#exp-ue-liste-ville').val());
            };
        }

        if (findSig(params.id_municipalite, params.id_ue)) {
            tenueAJourModal.ouvrirModalCreationEvenement(params);
        } else {
            infos.ajouterMessageToast({
                message: "Vous ne pouvez pas créer un évènement n'ayant pas de correspondance sur la carte ",
                messageDuree: 5000,
                messageCouleur: 'red'
            });
        }


    });


    $('#div-resultat-historique').off('click').on('click', 'a', function () {
        var dateEvenement = $(this).attr('date-evenement');
        //rafraichier les donnees
        var idUe = $(this).attr('id-ue');
        var municipalite = $(this).attr('id-mun');
        var matricule = $(this).attr('id-matricule');
        expUeChargerUe(dateEvenement, idUe, municipalite, matricule);
    });

    //Charge le tableau bâtiments
    $('#collapse-batiment').off('show.bs.collapse').on('show.bs.collapse', function () {
        var idUe = $('#exp-ue-body-information').find('#id-ue').text();

        if (idUe) {
            wait.start();
            expUegetBatimentUe(idUe, idMunicipalite);
            wait.stop();
        } else {
            destroyDataTable(table_batiment);
            $('#exp-ue-body-batiment').empty().append(getBanniereMessage('', "Sélectionner une unité d'évaluation"));
        }

    });


    $('#collapse-evenement').off('show.bs.collapse').on('show.bs.collapse', function () {
        ExplorateurUEchargeTableauEvenement();
    });

    //Charge le tableau photos
    $('#collapse-photos').off('show.bs.collapse').on('show.bs.collapse', function () {

        var dateEvenement = '2099-01-01';
        var idUe = $('#exp-ue-body-information').find('#id-ue').text();

        if (idUe) {
            wait.start();
            $('#exp-ue-body-photos-warning').empty();
            expUegetPhotosUe(idUe, dateEvenement);
            expUegetCroquisUe(idUe, dateEvenement);
            wait.stop();
        } else {
            $('#exp-ue-body-photos-warning').append(getBanniereMessage('', "Sélectionner une unité d'évaluation"));
        }

    });

    $(document).off('click', '.btn-photo-croquis-evenement').on('click', '.btn-photo-croquis-evenement', function () {
        var id_ue = $('#exp-ue-body-information').find('#id-ue').text();
        var date_evenement = $(this).attr("data-date-evenement");
        expUegetPhotosCroquisEvenementUe(id_ue, date_evenement);
    });

    $("body").on("change", "#select_batiment_docs", (e) => {
        getDocuments();
    });

    function getDocuments() {
        var idUe = $('#exp-ue-body-information').find('#id-ue').text();
        if (idUe) {
            wait.start();
            expUegetDocument(idUe);
            wait.stop();
        } else {
            destroyDataTable(table_document);
            $('#exp-ue-body-documents').empty().append(getBanniereMessage('', "Sélectionner une unité d'évaluation"));
        }
    }
    $('#btn-save-modal-actif').off('click').on('click', function (e) {
        const idUe = $(e.currentTarget).data('id_ue');
        save_actif_form(idUe);
    });
    $('#btn-delete-modal-actif').off('click').on('click', function (e) {
        const idUe = $(e.currentTarget).data('id_ue');
        const idActif = $(e.currentTarget).data('id_actif');

        delete_actif_form(idUe, idActif);
    });

    $('#btn-delete-modal-consommation').off('click').on('click', function (e) {
        const idUe = $(e.currentTarget).data('id_ue');
        const idActif = $(e.currentTarget).data('id_actif');
        const idConsommation = $(e.currentTarget).data('id_consommation');
        deleteConsommationForm(idUe, idActif, idConsommation);
    });

    //Charge le tableau documents
    $('#collapse-documents').off('show.bs.collapse').on('show.bs.collapse', getDocuments);

    $('#collapse-actif').off('show.bs.collapse').on('show.bs.collapse', getActifs);

    //Charge le tableau communcations
    $('#collapse-communication').off('show.bs.collapse').on('show.bs.collapse', function () {
        var idUe = $('#exp-ue-body-information').find('#id-ue').text();

        if (idUe) {
            expUeGetCommunicationUe(idUe, idMunicipalite);
        } else {
            destroyDataTable(table_communication);
            $('#exp-ue-body-communication').empty().append(getBanniereMessage('', "Sélectionner une unité d'évaluation"));
        }
        init_communication();
    });


    $('#btn-generer-pdf').off('click').on('click', function () {
        $('body').css('margin-right', '0px'); //PATCH POUR STOPPER LE MOUVEMENT DE LA PAGE VERS LA DROITE À L'OUVERTURE DU MODAL
        $("#exp-ue-langue").val("1");
        $("#exp-ue-langue").trigger("change");

        $('#modal-message-background').remove();
        $('.modal-backdrop:first').not('.stacked').addClass('stacked');

        var id_municipalite = $('#exp-ue-liste-ville').val();
        var auto_declaration = is_auto_declaration(id_municipalite);
        $("input[name='selection_auto_declaration'][value='aucun']").prop('checked', true);
        $('#exp-autres-photos').prop('checked', false);
        $('#exp-rens-adm').prop('checked', false);
        $('#exp-res-eval').prop('checked', false);
        $('#exp-terr-gen').prop('checked', false);
        $("input[name='selection_enquete_ventes']").prop('checked', true);


        $('#modal-impression').modal({
            show: true,
            backdrop: 'static'
        });
        var idxModal = ($('.modal:visible').length - 1);
        $('.modal-backdrop').not('.stacked').css('z-index', 9000 + (10 * idxModal) - 1);
        //$('#modal-impression').detach().appendTo('body');


        if (auto_declaration) {
            $("input[name='selection_auto_declaration'][value='avec_fiche']").prop('checked', true);
        }

        // #13368: Affichera le champ de date si une des checkbox auto-déclaration est active
        $("input[name*='auto_declaration'], input[name='selection_enquete_ventes']").on('click', function (e) {
            init_checkboxes_autodeclaration_pour_date_custom();
        });

        function init_checkboxes_autodeclaration_pour_date_custom() {
            if ($("input[name='selection_enquete_ventes']").is(':checked') || !$("input[name='selection_auto_declaration'][value='aucun']").is(':checked')) {
                $('#exp-date-custom-auto-declaration-wrapper').show();
            } else {
                $('#exp-date-custom-auto-declaration-wrapper').hide();
            }
        }

        init_checkboxes_autodeclaration_pour_date_custom();
        init_date_picker();
        masquesSelection.init('.datepicker-container');
        $("#exp-date-custom-auto-declaration").val(moment().format('YYYY-MM-DD'));
    });

    $('#btn-exp-assigner-evenement').off('click').on('click', function () {
        var variableAssignerEtEtat = {
            id: "tenue-a-jour-modal-assigner-et-etat",
            view: "/core/modal/",
            processus_id: "",
            estExplorateurmodule: true,
            titre: "Assigner / Modifier État",
            titre_supp: "",
            module: "",
            contenuHTML: "",
            template_view: "/gestion-roles/assigner-et-etat/",
            fournir_customParams_au_template_view: true,
            template_depart: "",
            sans_x: false,
            template_depart_view: "",
            url: "",
            taille: "tres-grande",
            resultat: "",
            resultat_depart: "",
            wizard: false,
            callback: tenueAJourModal.modalAssignerEtEtatLoaded,
            fournir_variableModal_au_callback: true,
            boutons: [{
                type: "cancel",
                label: "Annuler",
                title: "",
                classSupp: "",
                afficher: true
            }, {
                type: "save",
                label: "Sauvegarder",
                title: "",
                classSupp: "btn-primary",
                afficher: true,
                id: "btn-save-modal-assigne-explorateur",
                disabled: true,
            }]
        };
        setTimeout(function () {
            var callbacks = [expAssignerEvenementInitTableEvenement, ];
                // Pour initialiser la modale avec les bonnes données
                var customParams = {};
                customParams['id_municipalite'] = $('#exp-ue-liste-ville').val();
                var unitesEvaluation = $('#div-resultat-historique').find('.list-group-item');
                unitesEvaluation = unitesEvaluation.filter(":visible");
                var listeIdUe = [];
                $.each(unitesEvaluation, function (idx, value) {
                    var idUe = $(value).attr('id-ue');
                    if (idUe != '') listeIdUe.push(idUe);
                });
                var layerlistediv = $('#div-resultat-layer').find('[name="hid-filtres-layer"]');
                var layerliste = [];
                layerlistediv.each(function (){
                    var idMapLayer = $(this).val();
                    layerliste.push(idMapLayer);
                });
                customParams['listeIdUe'] = JSON.stringify(listeIdUe);
                customParams['layer'] = JSON.stringify(layerliste);

            fenetreModal.creerModal(variableAssignerEtEtat, customParams, callbacks, true);
        }, 0);
    });

    $('#exp-pdf-separe').off('click').on('click', function () {
        if ($('#exp-pdf-separe').is(':checked')) {
            $('#exp-en-inspection').prop('checked', false);
        }
    });

    $('#exp-en-inspection').off('click').on('click', function () {
        if ($('#exp-en-inspection').is(':checked')) {
            $('#exp-pdf-separe').prop('checked', false);
        }
    });

    $('#btn-imprimer-modal').off('click').on('click', function () {
        var unitesEvaluation = $('#div-resultat-historique').find('.list-group-item');
        unitesEvaluation = unitesEvaluation.filter(":visible");

        var listeIdUe = [];
        $.each(unitesEvaluation, function (idx, value) {
            var idUe = $(value).attr('id-ue');
            if (idUe != '') {
                listeIdUe.push(idUe);
            }
        });
        $("#liste_unites_evaluation").val(JSON.stringify(listeIdUe));
        var form = $('#form_impression_ue');
        $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            data: form.serialize(),
            success: function (response) {
                messageToastCompteur = 0;
                infos.ajouterMessageToast({
                    message: response,
                    icone: 'fa-envelope-o ',
                    iconeCouleur: 'green',
                    messageDuree: 5000
                });
                refreshMap();
            }
        });
    });

    $('#exp-ue-date-matrice').daterangepicker({
        alwaysShowCalendars: true,
        autoApply: true,
    }).next().on(ace.click_event, function () {
        $(this).prev().focus();
    });

    $('#exp-ue-date-matrice').off('apply.daterangepicker').on('apply.daterangepicker', function () {
        expUeInitChangeDate($(this).val(), null, true);
    });


    if ($('#listeUe').val() !== '') {
        chargerTaj();
    }

    init_communication();
}

function init_explorateur_ue_2(id_municipalite, date_evenement) {
    // artifice pour initialisé la map au départ sur l'ensemble du Québec, une carte doit-être initialisé au départ pour le bon fonctionnement de l'outil
    expUegetInfoUeAddMap();
    if (id_municipalite && date_evenement) {
        var bbox = {
            'derniereDateFermetureCycle': '2010-11-10',
            'derniereDateFermetureGeomatique': '2010-11-10',
            'xmax': '-75.2583983263144',
            'xmin': '-72.3930260161919',
            'ymax': '44.9688409017251',
            'ymin': '50.8478823529871'
        };

        // 17875
        expUeinitMap(id_municipalite, bbox, true, idMap, date_evenement);
    }
}

// La fonction d'initialisation a été scindée en deux parce que le module de communications interagit dans un modal avec l'explorateur d'UE et l'initialisation de la carte fait en sorte qu'on perd le zoom sur l'UE.
function init_explorateur_ue() {
    var municipalite_initiale = $('#id_municipalite_init').val();
    var matricule_initial = $('#matricule_init').val();
    var date_initiale = $('#date_evenement_init').val();
    //20517
    idMap = getInfoMap(municipalite_initiale, 31);
    if (municipalite_initiale || $('#idMunicipaliteStartup').val()) {
        $('#explorateur_ue_accordeons').removeClass('hidden');
        $('#explorateur_ue_warning').addClass('hidden');

        init_explorateur_ue_1();
        init_explorateur_ue_2(municipalite_initiale, date_initiale);

        if (matricule_initial) {
            setTimeout(function () {
                expUeChargerUe(date_initiale, null, municipalite_initiale, matricule_initial);
            }, 500);
        }
    } else {
        /* sers à positionner le contenu du warning .information-animated-explo */
        setTimeout(function () {
            var hauteur_warning = $(window).height() - $('.information-animated-explo').offset().top;
            $('.information-animated-explo').css('height', hauteur_warning + 'px');
        }, 0);

        setTimeout(function () {
            $('.information-animated-explo').addClass('loaded');
        }, 100);

        init_explorateur_ue_1();
        init_explorateur_ue_2(municipalite_initiale, date_initiale);
        // une fois que tout est initialisé on vérifie si l'utilisateur n'a qu'une municipalité et on la charge
        if ($('#exp-ue-liste-ville>option').length <= 2) {
            const firstOptionValue = $('#exp-ue-liste-ville>option:eq(1)').val();
            if (firstOptionValue) {
                $('#exp-ue-liste-ville>option:eq(1)').attr("selected", "selected").trigger('change');
               $('#exp-ue-liste-ville').select2('val', firstOptionValue)
            }
        }


    }
}

function expUeChargerUe(dateEvenement, idUe, municipalite, matricule) {
    var zoomToFeature = true;
    if (typeof (zoomClicked) !== 'undefined' && !zoomClicked) { // patch utilisée pour triggerFirstHistorique
        zoomToFeature = false;
        zoomClicked = true;
    }

    idMunicipalite = $('#exp-ue-liste-ville').val();
    //17875
    idMap = getInfoMap(municipalite, 31);

    if (municipalite != idMunicipalite) {
        idMunicipalite = municipalite;

        // -------------------------------------------------------------------------
        // change la ville dans le combo box pour choisir une ville
        $('#exp-ue-liste-ville option').each(function () {
            if ($(this).val() == idMunicipalite) {
                $("#exp-ue-liste-ville").select2("val", $(this).val());
            }
        });

        $('#modal-recherche').attr('recharger', 'oui');
        var nomMunicipalite = $("#exp-ue-liste-ville option:selected").text();
        $('#exp-ue-titre-mun').text(nomMunicipalite);

        $('#exp-ue-body-information').empty();
        $('#exp-ue-body-photo-principale').empty();
        // lors d'un changement de municipalite on reinitialise les voies publiques
        $('#voie-publique').find('option').remove().end();
        $('#voie-publique').append('<option value=""></option>');

        $('#no-civique').find('option').remove().end();
        $('#no-civique').append('<option value=""></option>');

        $('#exp-ue-vider').trigger('click', ['non']);

        if (!$('#exp-ue-ajouter-carte').is(':empty')) {
            if (dateEvenement.substring(0, 10) != $('#exp-ue-date-matrice').val()) {
                $('#exp-ue-date-matrice').val(dateEvenement.substring(0, 10));
            }

            expUegetInfoUeAddMap();

            getBboxMunicipalite(idMunicipalite, function (bbox) {

                if (bbox.DateDonneesGerflo != null) {
                    $('#date-donnees-gerflo').text("Données provenant de GeRFLo en date du : " + bbox.DateDonneesGerflo);
                } else {
                    $('#date-donnees-gerflo').text("");
                }

                myBbox = bbox;
            });


            //17875
            expUeinitMap(idMunicipalite, myBbox, true, idMap, dateEvenement);


            setTimeout(function () {
                expUegetInfoUe(idMunicipalite, matricule, dateEvenement, idUe);
                zoomToSelect(matricule, zoomToFeature);
            }, 600);
        } else {
            newWindow.expUegetInfoUeAddMap;
            getBboxMunicipalite(idMunicipalite, function (bbox) {
                var nomMunicipalite = $("#exp-ue-liste-ville option:selected").text();

                //17875
                newWindow.expUeinitMapNewBrowser(idMunicipalite, bbox, $('#urlGeoserver').val(), nomMunicipalite, true, idMap);


            });
            expUegetInfoUe(idMunicipalite, matricule, dateEvenement, idUe);
            newWindow.zoomToSelect(myProperties, zoomToFeature);
        }

    } else {
        if (!$('#exp-ue-ajouter-carte').is(':empty')) {
            expUegetInfoUe(idMunicipalite, matricule, dateEvenement, idUe);
            zoomToSelect(matricule, zoomToFeature);
        }
        else {
            expUegetInfoUe(idMunicipalite, matricule, dateEvenement, idUe);
            newWindow.zoomToSelect(myProperties, zoomToFeature);
        }
    }
}

function expUeInitChangeDate(date, callback, force) {
    date = date.substring(0, 10);
    if (!force) {
        if (date == $('#exp-ue-date-matrice').val()) {
            if (callback) {
                callback();
            }
            return;
        }
    }

    $('#exp-ue-date-matrice').val(date);

    var bbox;
    var bounds;
    if (!$('#exp-ue-ajouter-carte').is(':empty')) {
        bounds = map.getBounds();
        bbox = {
            ymin: bounds._southWest.lat,
            xmin: bounds._southWest.lng,
            ymax: bounds._northEast.lat,
            xmax: bounds._northEast.lng
        };
        var idMun = (typeof (idMunicipalite) != 'undefined' ? idMunicipalite : '00000');

        // 17875
        expUeinitMap(idMun, bbox, true, idMap, date, callback);


    } else {
        var nomMunicipalite = $("#exp-ue-liste-ville option:selected").text();
        bounds = newWindow.map.getBounds();
        bbox = {
            ymin: bounds._southWest.lat,
            xmin: bounds._southWest.lng,
            ymax: bounds._northEast.lat,
            xmax: bounds._northEast.lng
        };

        // 17875
        newWindow.expUeinitMapNewBrowser(idMunicipalite, bbox, $('#urlGeoserver').val(), nomMunicipalite, true, idMap);

    }
}

function expUegetInfoUeAddMap() {
    $('#exp-ue-ajouter-carte').empty().append(
        '<div id="map-controls" class="map-controls-container map-controls-container-alt"></div>' +
        '<div id="map" class="ombre carte-exp-ue-empty leaflet-container-alt">' +
        '<i class="fa fa-map-marker carte-exp-ue-empty-icon" aria-hidden="true"></i>' +
        '</div>'
    );
    var hauteur = 480;
    $('#map').css("height", hauteur + "px");
}

function zoomToSelect(matricule, zoomToFeature) {
    if (typeof (zoomToFeature) == 'undefined') {
        zoomToFeature = true;
    }
    map.selectFeatureByAttribute(matricule, true, zoomToFeature);
}

function postSelectFeatureOnexpUeinitMap(properties) {

    var dateEvenement = $("#exp-ue-date-matrice").val() + ' 23:59:59';


    var nomMunicipalite = $("#exp-ue-liste-ville option:selected").text();

    //Verification de quel'usager appuie pas sur une ue
    if (properties.matricule !== undefined) {
        expUegetInfoUe(properties.idMunicipalite, properties.matricule, dateEvenement, properties.id_ue, nomMunicipalite, properties.lat, properties.lng); //nomMunicipalite,properties.lat,properties.lng
        myProperties = properties;
    }

}

function ajouterfiltrelayer(layer_ids_liste) {
    //var layer_ids_liste = JSON.stringify(layer_ids_liste)
    var divlayerHistorique = $('#div-resultat-layer');

    for (var i = 0; i < layer_ids_liste.length; i++) {
        var idlayer = layer_ids_liste[i];
        var layer = '<input type="hidden" name="hid-filtres-layer" value="' + idlayer + '" />';
        divlayerHistorique.prepend(layer);
    }
}

function effacerfiltrelayer() {
    var divlayerHistorique = $('#div-resultat-layer');
    divlayerHistorique.find('[name="hid-filtres-layer"]').remove();
}

// appelé seulement lorsqu'on clique une UE sur la carte, me semble
function ajouterHistorique(idUe, idMunicipalite, matricule, adresse = []) {
    var divResultatHistorique = $('#div-resultat-historique');
    var dateEvenement = $('#exp-ue-date-matrice').val() + ' 23:59:59';

    var divString = getDivHistoriqueString(idUe, idMunicipalite, idMunicipalite, matricule, adresse, dateEvenement);


    if (divResultatHistorique.is(':empty')) {
        divResultatHistorique.prepend(divString);
    } else {

        var is_in = true;
        divResultatHistorique.find('a').each(function () {
            var idHisto = $(this).attr('id-ue');
            if (idUe == idHisto) {
                is_in = false;
            }
        });

        if (is_in) {
            divResultatHistorique.prepend(divString);
        }
    }

    // On rend accessible le bouton d'impression en lot s'il y a au moin 1 unité d'évaluation dans la liste d'historique des résultats
    var unitesEvaluation = divResultatHistorique.find('.list-group-item');
    if (unitesEvaluation.length > 0) {
        $('#btn-generer-pdf').prop('disabled', false);
        $('#btn-exp-assigner-evenement').prop('disabled', false);
    }
    //////////////////////////////////////////////////////////////////////////////

    divResultatHistorique.off('click', 'i').on('click', 'i', function () {
        var id = $(this).attr('id');
        var idUe = id.replace("-x", "");
        enleverHistorique(idUe);
        if ($('#listeUe').val()) {
            $('#listeUe').val(JSON.stringify(JSON.parse($('#listeUe').val()).filter(function (e) {
                return e.id_ue != idUe;
            })));
        }

        var matricule = $(this).parent().attr('id-matricule');
        enleverSelectionCarte(map, matricule);

        //retourne le nombre d'éléments dans l'historique de recherche à la badge dans le bouton
        $('#div-resultat-historique-nb').text($('#div-resultat-historique > div').length);

        return false;
    });
    $('#div-resultat-historique-nb').text($('#div-resultat-historique > div').length);
}

function enleverHistorique(idUe) {
    var divResultatHistorique = $('#div-resultat-historique');

    var element = "#" + idUe + "_div";
    divResultatHistorique.find(element).remove();
    var unitesEvaluation = divResultatHistorique.find('.list-group-item');

    // On disable le bouton d'impression en lot s'il n'y a pas au moin 1 unité d'évaluation dans la liste d'historique des résultats
    if (unitesEvaluation.length == 0) {
        $('#btn-generer-pdf').prop('disabled', true);
        $('#btn-exp-assigner-evenement').prop('disabled', true);

    }
}

function ajouterSelectionCarte(mapAjout, geometry, properties) {
    var matricule = properties.matricule;

    // par exemple si on fouille dans le passé
    if (typeof (matricule) == 'undefined') {
        return;
    }

    var layer = getSelectionLayer(mapAjout, matricule);
    if (layer != null) {
        return;
    }

    // sert plus tard à copier les infos de la géométrie des layers dans copierSelectionLayers()
    if (!properties.geometry) {
        properties.geometry = geometry;
    }

    var geo = {'type': 'Feature', 'geometry': geometry, 'properties': properties};

    if (!$.isEmptyObject(geo.geometry)) {
        let style = {
            "color": "#f03",
            "weight": 6,
            "opacity": 0.2,
            "fillColor": "#ffff00",
            "fillOpacity": 0.5,
            "clickable": false
        };

        layer = L.geoJson(geo, {
            style: style
        }).addTo(mapAjout);

        layer.properties = geo.properties;
        layer.properties.layerType = 'selection';
        explorateur_selection_carte_layers.push(layer);
    }
}

function enleverSelectionCarte(map, matricule) {
    const layer = getSelectionLayer(map, matricule);
    if (layer != null) {
        map.removeLayer(layer);
        explorateur_selection_carte_layers = explorateur_selection_carte_layers.filter(function(l) {
            return l.properties && l.properties.matricule &&
                   l.properties.matricule.substring(0, 12) !== matricule.substring(0, 12);
        });
    }
}

function copierSelectionLayers(mapSrc, mapDest) {
    mapSrc.eachLayer(function (layer) {
        if (layer.properties && layer.properties.layerType == 'selection' && layer.properties.matricule) {
            ajouterSelectionCarte(mapDest, layer.properties.geometry, layer.properties);
        }
    });

}


function getSelectionLayer(map, matricule) {
    var parentMatricule = matricule.substring(0, 12);
    var parentLayer = null;

    map.eachLayer(function (layer) {
        if (layer.properties && layer.properties.layerType == 'selection' && layer.properties.matricule) {
            if (layer.properties.matricule.substring(0, 12) == parentMatricule) {
                parentLayer = layer;
            }
        }
    });

    return parentLayer;
}

function expUegetInfoUe(idMunicipalite, matricule, dateEvenement, idUe, nomMunicipalite) {
    wait.start();
    // DM: faut passer une heure précise pour éviter que ça plante. Aussi c'est pour savoir exactement ce qu'on veut plutôt que laisser ca au hasard
    // idéalement ce IF ne devrait pas être là, et il devrait déja avoir une heure au dateEvenement en entrée
    if (dateEvenement.length == 10) {
        dateEvenement += ' 23:59:59';
    }

    collapseAccordeonsExplorateurUe();
    detruireDatatablesExplorateurUe();
    viderAccordeonsExplorateurUe();

    // Cache la zone des badges sur le header de l'accordeon Communication
    $('#communication_badge_header').hide();

    myProperties = {
        "id_municipalite": idMunicipalite,
        "matricule": matricule,
        "date_evenement": dateEvenement,
        "id_ue": idUe,
        "nom_municipalite": nomMunicipalite
    };
    $.ajax({
        type: "GET",
        url: `/gestion-roles/exp-ue/info-ue/${idMunicipalite}/`,
        data: {
            matricule: matricule,
            date_evenement: dateEvenement,
            id_ue: idUe,
        },
        dataType: 'json',
        success: function (data) {
            if (data == '') {
                cleanExplorateurUe();
                infos.ajouterMessageToast({message: "Il n'y a pas de donnée disponible pour cette unité d'évaluation à cette date."});
            }
            // charge les information dans l'accordeon resume
            else {
                $('#exp-ue-body-information').html(data.html);

                let matricule_html = $('#matricule').val();
                idUe = $('#id-ue').text(); // cette variable était vide si on avait cliqué dans la carte

                expUegetPhotoPrincipale('2099-01-01', idUe);

                /////////////////////////////////////////////////////////////////////////////
                // Ajout à l'historique de résultat
                /////////////////////////////////////////////////////////////////////////////
                var adresse = $('#adresse-ue-complete').text();

                var layer_ids_liste = [];
                $(".ac-container").find('.menu-item-checkbox input[type=checkbox]').each(function () {
                    if ($(this).prop('checked')) {
                        var idMapLayer = $(this).attr('id-map-layer');
                        layer_ids_liste.push(idMapLayer);
                    }
                });
                ajouterfiltrelayer(layer_ids_liste);
                ajouterHistorique(idUe, idMunicipalite, matricule_html, adresse);

                // On définit les liens permettant de voir l'info des autres ues associés
                var autresUes = $('#section-autre_ue-associe');
                if (autresUes.length > 0) {
                    $('.autre-ue-associe').off('click').on('click', function () {
                        var autreIdUe = $(this).attr('id-ue');
                        var autreMatricule = $(this).text(); // .substr(0,12); // Important de prendre le matricule court afin qu'on recherche tous les autres ues associés côté serveur
                        expUegetInfoUe(idMunicipalite, autreMatricule, dateEvenement, autreIdUe);
                        return false;
                    });
                }

                // Affiche les informations du nombre de communications dans le header de l'accordeon communications
                $('#communication_badge_a_traiter').html(data.nb_communications.a_traiter);
                $('#communication_badge_total').html(data.nb_communications.total);
                $('#communication_badge_header').show();
                expUegethistoriqueLots(idUe, false);

                $('#btnVoirUeSigWeb2').parent().html(data.btn_sig);
                $('#btnVoirUeSigWeb2').show();

                //#16461
                $('.hyperlien-lot').off('click').on('click', function () {
                    var listLot = [];
                    var num_lot = this.text;
                    listLot.push(num_lot);
                    map.selectFeatureLotByAttribute(num_lot, true, true);
                });
                $('.popover-dismiss').popover({trigger: 'focus'});
            }
            wait.stop();
        }
    });

}

function expUegethistoriqueLots(idUe, estsigweb2) {
    $('#btn-exp-historique-lots').off('click').on('click', function () {
        var variableAssignerA = {
            id: "explorateur-modal",
            view: "/core/modal/",
            processus_id: "",
            estExplorateurmodule: true,
            titre: "Historique des lots",
            titre_supp: "",
            module: "",
            contenuHTML: "",
            template_view: "/gestion-roles/exp-ue/charger-historique-lots/",
            template: "",
            template_depart: "",
            sans_x: false,
            template_depart_view: "",
            url: "",
            taille: "tres-grande",
            resultat: "",
            resultat_depart: "",
            wizard: false,
            boutons: [
                {
                    type: "cancel",
                    label: "Fermer",
                    title: "",
                    classSupp: "",
                    afficher: true
                }
            ]
        };
        var client_evaluation = $(this).data("client-evaluation");
        setTimeout(function () {
            var callbacks = [function () {
                controlesFormulaires.redimentionnerTextarea();
                tablehistoriquelots(idUe, estsigweb2, client_evaluation);
            }];
            var params = {};
            fenetreModal.creerModal(variableAssignerA, params, callbacks);
        }, 0);
    });
}

function expUegetPhotoPrincipale(dateEvenement, idUe) {
    let params = {
        "date_evenement": dateEvenement,
    };
    let success_cb = function (response) {
        $('#exp-ue-body-photo-principale').html(response);
        wait.stop();
    }
    call_ajax(`/gestion-roles/exp-ue/${idUe}/photo-principale/`, 'GET', params, success_cb)
}


function expUegetBatimentUe(idUe, idMunicipalite) {
    if (!$('#exp-ue-body-batiment').is(':empty')) return
    var params = {
        "id_municipalite": idMunicipalite,
        "id_ue": idUe,
        "rechercher_historique": false
    };
    let success_cb = function (response) {
        $('#exp-ue-body-batiment').html(response);
        let options = {
            columnDefs: [{
              targets  : 'no-sort',
              orderable: false,
            }],
            stateSave: false,
            drawCallback: function () {
                var expUeBatimentPhotoPrincipale = $('#exp-ue-batiment-photo-principale');
                ajusterTailleImage(expUeBatimentPhotoPrincipale.find('img'), '100px', '80px');
                initAceThumbnails('colorbox-photo-principale');
            }
        };
        initTableDatatable($('#exp-ue-table-batiment'), options)
    };
    call_ajax("/gestion-roles/exp-ue/id-batiment/", 'POST', params, success_cb)
}


function expUegetDocument(idUe, dateEvenement) {
    dateEvenement = dateEvenement ? dateEvenement : new Date(moment().format('YYYY-MM-DD')).toJSON();

    const params = {
        "date_evenement": dateEvenement,
        "id_ue": idUe,
        "id_municipalite": idMunicipalite,
        'filtre': $("#select_batiment_docs").val()
    };
    const url = "/gestion-roles/exp-ue/document/";
    const success_cb = function (resp) {
        $('#exp-ue-body-documents').html(resp.render);
        if ($(resp.render).find('#btn-exp-ue-telecharger-document').length === 0) {
            destroyDataTable(table_document);
            table_document = $('#table-document').dataTable({
                "order": [],
                "columnDefs": [{
                    "targets": 'no-sort',
                    "orderable": false,
                }]
            });
        }
        // # 15080 galleries sur les miniatures de la première colone du tableau
        initAceThumbnails('colorbox-autres-documents');
    };
    call_ajax(url, "GET", params, success_cb, null, false, 'json');
}

function expUegetActifs(idUe) {
    const url = `/gestion-roles/exp-ue/${idUe}/actifs/`;
    const success_cb = function (resp) {
        const contenuActif = $("#exp-ue-body-actifs");
        $(contenuActif).empty();
        $(contenuActif).html(resp.render);
        if ($(resp.render).find('#btn-exp-ue-telecharger-document').length === 0) {
            const table = $('#table-actifs');
            destroyDataTable(table);
            $(table).dataTable({
                "order": [],
                "columnDefs": [{
                    "targets": 'no-sort',
                    "orderable": false,
                }]
            });
        }
    };
    call_ajax(url, "GET", {}, success_cb);
}
function ouvrirModalConsommations(idUe, idActif) {
    const url = `/gestion-roles/exp-ue/${idUe}/actif/${idActif}/consommations/`;
    const success_cb = function (resp) {
        const $modal = $("#modal-list-consommation-energie");
        const contenuConsommations = $modal.find('.modal-body');
        $(contenuConsommations).empty();
        $(contenuConsommations).html(resp.template);
        const table = $('#table-consommations');
        destroyDataTable(table);
        $(table).dataTable({
            "order": [],
            "columnDefs": [{
                "targets": 'no-sort',
                "orderable": false,
            }]
        });
        $modal.modal('show');
    };
    call_ajax(url, "GET", {}, success_cb);
}

function ouvrir_modal_actif(idUe, idActif) {
    const url = `/gestion-roles/exp-ue/${idUe}/actif/${idActif ? idActif + '/' : ''}`;
    const $modal = $("#modal-actif");
    wait.start();
    const success_cb = function (resp) {
        const title = idActif ? "Modifier un actif" : "Ajouter un actif";
        const btn_save = $modal.find('.modal-body-create-update, #btn-save-modal-actif');

        $modal.find('.modal-body-create-update').html(resp.template);
        $modal.find('.modal-title').html(title);

        $(btn_save).data('id_ue', idUe);
        $(btn_save).show();

        $modal.find('.modal-body-delete, #btn-delete-modal-actif').hide();

        $modal.modal('show');
        $modal.find('.date-picker').each(function () {
            initDatepickerWithOptions(this, {
                parentEl: $(this).closest('.datepicker-container'),
                maxDate: new Date(),
                showCustomRangeLabel: false,
                autoUpdateInput: false,
            });
        });

    };
    call_ajax(url, "GET", {}, success_cb);
}

function ouvrirModalConsommation(idUe, idActif, idConsommation) {
    const url = `/gestion-roles/exp-ue/${idUe}/actif/${idActif}/consommation/${idConsommation ? idConsommation + '/' : ''}`;
    const $modal = $("#modal-consommation");
    wait.start();
    const success_cb = function (resp) {
        const title = idConsommation ? "Modifier une consommation" : "Ajouter une consommation";
        const btn_save = $modal.find('#btn-save-modal-consommation');

        $modal.find('.modal-body-create-update').html(resp.template).show();
        $modal.find('.modal-title').html(title);
        $modal.find('form').attr('action', url);

        $(btn_save).data('id_ue', idUe).data('id_actif', idActif);
        $(btn_save).off('click').on('click', saveConsommationForm);
        $(btn_save).show();

        $modal.find('.modal-body-delete, #btn-delete-modal-consommation').hide();
        $modal.find('.date-picker').each(function () {
            initDatepickerWithOptions(this, {
                parentEl: $(this).closest('.datepicker-container'),
                maxDate: new Date(),
                showCustomRangeLabel: false,
                autoUpdateInput: false,
            });
        });

        $modal.modal('show');
    };
    call_ajax(url, "GET", {}, success_cb);
}

function ouvrirModalDeleteConsommation(idUe, idActif, idConsommation) {
    const $modal = $("#modal-consommation");
    const btn_delete = $modal.find('#btn-delete-modal-consommation');
    const title = "Supprimer une consommation";

    $modal.find('.modal-title').html(title);
    $modal.find('.modal-body-create-update').hide();
    $modal.find('.modal-body-delete').show();
    $(btn_delete).show();
    $(btn_delete).data('id_ue', idUe);
    $(btn_delete).data('id_actif', idActif);
    $(btn_delete).data('id_consommation', idConsommation);
    $modal.find('#btn-save-modal-consommation').hide();

    $modal.modal('show');
}

function saveConsommationForm() {
    const $form = $("#consommation-form");
    const success_cb = function (resp) {
        const $modal = $("#modal-consommation");
        const btn_save = $modal.find('#btn-save-modal-consommation');
        const idUe = $(btn_save).data('id_ue');
        const idActif = $(btn_save).data('id_actif');
        ouvrirModalConsommations(idUe, idActif);
        infos.ajouterMessageToast({
            message: resp.message,
            messageDuree: 3500,
            icone: 'fa-check-circle-o',
            iconeCouleur: 'green'
        });
        $modal.modal('hide');

    };
    const error_cb = function (resp) {
        const resp_json = resp.responseJSON;
        const $modal = $("#modal-consommation");
        $($modal).find(".modal-body-create-update").html(resp_json.template);
        $($modal).scrollTop(0);
        infos.ajouterMessageToast({
            message: resp.message,
            messageDuree: 3500,
            icone: 'fa-times-circle-o',
            iconeCouleur: 'red'
        });
    };
    submit_form($form, success_cb, error_cb);

}

function ouvrir_modal_delete_actif(idUe, idActif) {
    const $modal = $("#modal-actif");
    const btn_delete = $modal.find('#btn-delete-modal-actif');
    const title = "Supprimer un actif";
    $modal.find('.modal-title').html(title);
    $modal.find('.modal-body-create-update').hide();
    $modal.find('.modal-body-delete').show();
    $(btn_delete).show();
    $(btn_delete).data('id_ue', idUe);
    $(btn_delete).data('id_actif', idActif);
    $modal.find('#btn-save-modal-actif').hide();

    $modal.modal('show');
}

function save_actif_form(idUe) {
    const $form = $("#actif-form");

    const success_cb = function (resp) {
        const $modal = $("#modal-actif");

        $modal.modal('hide');
        infos.ajouterMessageToast({
            message: resp.message,
            messageDuree: 3500,
            icone: 'fa-check-circle-o',
            iconeCouleur: 'green'
        });
    expUegetActifs(idUe);

    };
    const error_cb = function (resp) {
        const resp_json = resp.responseJSON;
        const $modal = $("#modal-actif");
        $($modal).find(".modal-body-create-update").html(resp_json.template);
        $($modal).scrollTop(0);
        infos.ajouterMessageToast({
            message: resp.message,
            messageDuree: 3500,
            icone: 'fa-times-circle-o',
            iconeCouleur: 'red'
        });
    };

    submit_form($form, success_cb, error_cb);
}

function delete_actif_form(idUe, idActif) {
    const $modal = $("#modal-actif");

    wait.start();
    const url = `/gestion-roles/exp-ue/${idUe}/actif/${idActif}/`;
    call_ajax(url, "DELETE", null, function (resp) {
        expUegetActifs(idUe);
        $modal.modal('hide');
        infos.ajouterMessageToast({
            message: resp.message,
            messageDuree: 3500,
            icone: 'fa-check-circle-o',
            iconeCouleur: 'green'
        });
    });
}

function deleteConsommationForm(idUe, idActif, idConsommation) {
    const $modal = $("#modal-consommation");

    wait.start();
    const url = `/gestion-roles/exp-ue/${idUe}/actif/${idActif}/consommation/${idConsommation}/`;
    call_ajax(url, "DELETE", null, function (resp) {
        expUegetActifs(idUe);
        $modal.modal('hide');
        infos.ajouterMessageToast({
            message: resp.message,
            messageDuree: 3500,
            icone: 'fa-check-circle-o',
            iconeCouleur: 'green'
        });
    });
}

/**
 * Description
 * param {object} params - objet qui contient au minimum params.id_ue et qui peut aussi contenir params.callback_fermeture_modal.
 * param {string} dateEvenement - Date de l'évènement.
 */
function expUegetEvenementUe(params, dateEvenement) {
    destroyDataTable(table_evenement);
    $('#exp-ue-body-evenement').empty();

    const parametres = {
        "date_evenement": dateEvenement,
        "id_ue": params.id_ue,
        "id_municipalite": params.id_municipalite
    };

    $.ajax({
        type: "POST",
        url: "/gestion-roles/exp-ue/evenement/",
        data: parametres,
        dataType: 'html',
        success: function (response) {
            // charge les informations dans l'accordeon evenement
            $('#exp-ue-body-evenement').html(response);

            table_evenement = $('#table-evenements').dataTable({
                order: [],
                columnDefs: [{
                    targets: 'no-sort',
                    orderable: false,
                }],
                fixedColumns: {
                    leftColumns: 3,
                },
                dom: '<"datatables-top-pagination"<"datatables-topp-left"Bl><"datatables-topp-right"f>>t<"datatables-top-pagination"<"datatables-topp-left"i><"datatables-topp-right"p>>',
                buttons: [
                    'colvis',
                    'colvisRestore',
                ],
                scrollCollapse: true,
                scrollX: true,
                scrollY: '70vh',
                initComplete: function (settings, json) {
                    const keyLocalStorage = getKeyLocalStorage(settings.nTable)
                    getNbrColonneMasquees(keyLocalStorage);
                    $(".table-scroller-custom .dataTables_scrollBody").scroll(function () {
                        $(this).closest(".table-scroller-custom").find(".dataTables_scrollHead").css({
                            'left': -$(this).scrollLeft()
                        });
                    });
                }
            });

            init_reactiver_button_formulaire(params, dateEvenement)
            tenueAJourModalBoutons.initBoutonsTableEvenement(params);
        }
    });
}

function init_reactiver_button_formulaire(params, dateEvenement) {
    const btn = $('.btn-reactivate-formulaire, .btn-desassigner-citoyen')
    $(btn).on('click', function () {
        const url = $(btn).attr('data-url');
        const success_cb = function () {
            // On recharge les événements pour que le bouton réapparaisse
            expUegetEvenementUe(params, dateEvenement)
        };
        call_ajax(url, 'GET', null, success_cb);
    });
}

function expUegetPhotosUe(idUe, dateEvenement) {

    if (!$('#div-photo').is(':empty')) return;
    var params = {
        "date_evenement": dateEvenement,
        "id_ue": idUe
    };

    let success_cb = function (response) {
        $('#div-photo').html(response);
        var divPhoto = $('#exp-ue-photo');
        ajusterTailleImage(divPhoto.find('img'), '100px', '80px');
        initAceThumbnails('colorbox-photo');
    };
    call_ajax(`/gestion-roles/exp-ue/${idUe}/photos/`, 'GET', params, success_cb);
}

function expUegetCroquisUe(idUe, dateEvenement) {
    if (!$('#div-croquis').is(':empty')) return;
    var params = {
        "date_evenement": dateEvenement,
        "id_ue": idUe
    };

    let success_cb = function (response) {
        $('#div-croquis').html(response);
        var divCroquis = $('#exp-ue-croquis');
        ajusterTailleImage(divCroquis.find('img'), '100px', '80px');
        initAceThumbnails('colorbox-croquis');
    };
    call_ajax(`/gestion-roles/exp-ue/${idUe}/croquis/`, 'GET', params, success_cb);
}


function expUegetPhotosCroquisEvenementUe(id_ue, date_evenement) {
    var params = {
        "date_evenement": date_evenement,
        "id_ue": id_ue
    };

    let success_cb = function(response) {
        $('#div-photos-croquis-evenement').html(response);
        initAceThumbnails('colorbox-photos-croquis-evenements');
        $("#exp-ue-photo-croquis-evenement").find(".cboxElement").first().trigger("click");
    };
    call_ajax(`/gestion-roles/exp-ue/${id_ue}/croquis-photos-evenement/`, 'GET', params, success_cb)
}


function is_client_non_live(idMunicipalite) {
    var params = {'idMunicipalite': idMunicipalite};
    var client_non_live;

    $.ajax({
        type: "GET",
        url: "/gestion-roles/tenue-a-jour/explorateur-ue/get-client-non-live/",
        data: params,
        async: false,
        dataType: 'json',
        success: function (response) {
            client_non_live = response[0].response;
        }
    });
    return client_non_live;

}

function expUeinitMap(idMunicipalite, bbox, changeMun, idMap, dateEvenement, callback) {
    if ($('#explorateur_ue_accordeons').hasClass('hidden')) {
        $('#explorateur_ue_accordeons').removeClass('hidden');
        $('#explorateur_ue_warning').addClass('hidden');
    }

    if ($('#map').hasClass('carte-exp-ue-empty')) {
        $('#map').removeClass('carte-exp-ue-empty');
        $('#map').children(".carte-exp-ue-empty-icon").remove();
    }

    if ($('#exp-ue-ajouter-carte').is(':visible')) {
        expUeDemmarerInitMap(idMunicipalite, bbox, changeMun, idMap, dateEvenement, callback);

    } else {
        $('#exp-ue-collapse-information').collapse('show');
        $('#exp-ue-collapse-information').one('shown.bs.collapse', function () {
            expUeDemmarerInitMap(idMunicipalite, bbox, changeMun, idMap, dateEvenement, callback);

        });
    }
}

function expUeDemmarerInitMap(idMunicipalite, bbox, changeMun, idMap, dateEvenement, callback) {
    //TODO: Prendre la date effective de l'évènement d'opération cadastrale la plus récente pour une municipalité
    init_context_preferences_layer();

    if (typeof (dateEvenement) == 'undefined') {
        dateEvenement = $('#exp-ue-date-matrice').val() + " 23:59:59";
    }
    var client_non_live = is_client_non_live(idMunicipalite);
    /*SI LA MAP EXISTE DÉJÀ ON LA DÉTRUIT AVANT DE LA RECRÉER AVEC LES DONNÉES D'UNE AUTRE MUNICIPALITÉ*/
    if (changeMun) {
        effacerfiltrelayer();
        if (map) {
            try {
                map.remove();
                map.removeLayer(googleStreets);
            } // Ceci plante dans i.e. alors...
            catch (err) {
            }

        }
    }

    map = new L.Map('map', {center: new L.LatLng(46.0, -72.4), zoom: 6, maxZoom: 23, zoomSnap: 0.3});
    map.removeControl(map.attributionControl);

    var urlGeoserver = $('#urlGeoserver').val();
    //17875
    var baseMaps = getBaseMap('carte_1');

    map.addLayer(googleStreets);

    var overlays = [{}];

    var options = {
        container_width: "250px",
        group_maxHeight: "100px",
        container_maxHeight: "425px",
        exclusive: false
    };

    var control = L.Control.styledLayerControl(baseMaps, overlays, options);
    map.addControl(control);
    $("#map-controls").append(control.getContainer());
    //let urlGeoserver = $('#urlGeoserver').val();

    //ON CONFIGURE AUTOMATIQUEMENT LES LAYERS DE LA MAP DEPUIS LA BD À L'AIDE DE NOTRE PLUGIN LEAFLET
    map = map.buildEvbMap({
        idMap: idMap,
        zoomToMapExtent: true,
        controlLayers: control, //layerCtl,
        urlGeoserver: urlGeoserver,
        urlOrthosGeoserver: $('#urlOrthosGeoserver').val(),
        idMunicipalite: idMunicipalite,
        bbox: bbox,
        dateEvenement: dateEvenement,
        clientNonLive: client_non_live,
        decocheUe: $('#decocheUe').val(),
        callback: function () {
            if (typeof (callback) != 'undefined' && callback) {
                // appeler le callback après initialisation de la map
                callback();
            }
        }
    });
    map._layerControl = control;
    map.whenReady(function() {
        init_layer_group_checkbox_and_layer_menu_styles();
    });

    function activerSelectFeature() {
        //Permet de selectionner une unité d'évaluation sur la carte
        map.EnableSelectFeatureByAttribute({
            url: '/gestion-roles/tenue-a-jour/operation-ue/unite-evaluation.json/',
            zoomToFeature: true,
            idMunicipalite: idMunicipalite,
            dateEvenement: dateEvenement,
            callbackBeforeSelect: function () {
            },
            callback: function (properties) {
                if (properties.properties.error != 'pas_de_carte') {
                    ajouterSelectionCarte(map, properties.geometry, properties);
                } else {
                    infos.ajouterMessageToast({
                        message: "Nous ne retrouvons pas les lots sur la matrice graphique ",
                        messageDuree: 5000,
                        messageCouleur: 'red'
                    });
                }
                wait.stop();
            }
        });

        //******************************************************************

        map.EnableSelectTAJFeatureByAttribute({
            url: '/gestion-roles/tenue-a-jour/operation-ue/unite-evaluation-taj.json/',
            zoomToFeature: true,
            idMunicipalite: idMunicipalite,
            dateEvenement: dateEvenement,
            callbackBeforeSelect: function () {
            },
            callback: function (properties) {

                if (properties == null) {
                    infos.ajouterMessageToast({
                        message: "Oops ",
                        messageDuree: 5000,
                        messageCouleur: 'red'
                    });
                }

            }
        });

        //#16461 : initialise la recherche par lot
        map.EnableSelectLotFeatureByAttribute({
            url: '/fiche_role/lot.json/',
            zoomToFeature: true,
            idMunicipalite: idMunicipalite,
            dateEvenement: dateEvenement,
            callback: function (properties) {

            }
        });

        //******************************************************************


        map.EnableSelectFeatureOnMap({
            url: '/gestion-roles/tenue-a-jour/operation-ue/unite-evaluation.json/',
            zoomToFeature: true,
            idMunicipalite: idMunicipalite,
            dateEvenement: dateEvenement,
            callback: function (properties) {
                if (!$.isEmptyObject(properties)) {

                    idMunicipalite = properties.idMunicipalite;

                    postSelectFeatureOnexpUeinitMap(properties);

                    //Verification de quel'usager appuie pas sur une ue
                    if (properties.matricule !== undefined) {
                        ajouterSelectionCarte(map, properties.geometry, properties);
                    } else {

                        if (properties.properties.error == 'pas_de_role') {
                            infos.ajouterMessageToast({message: "Les données du rôle d'évaluation ne sont pas encore migrées"});
                        } else {
                            infos.ajouterMessageToast({message: "Attention veuillez sélectionner une unité d'évaluation"});
                        }

                        cleanExplorateurUe();
                        wait.stop();
                    }
                } else {
                    cleanExplorateurUe();
                    wait.stop();
                }
            },
            callbackBeforeSelect: function () {
                wait.start();
            }/*,

             callbackAfterSelect: function (response) {
             ajouterSelectionCarte(response);
             }*/

        });
    }

    activerSelectFeature();

    L.easyButton('fa-globe', function () {

        // dans le cas où on déclanche pas une requete ajax, il faut definir le PREFIXE_URL (intranet)
        window.activeMapLayerIds = getActiveLayersIds();
        $('#exp-ue-ajouter-carte').html('');
        newWindow = window.open('/gestion-roles/exp-ue/carto/agrandir/', 'carto', "height=" + $(window).height() - 500 + ",width=" + $(window).width() - 500 + "");

        //callback de l'ouverture de la fenêtre
        newWindow.onload = function () {

            try {
                map.remove();
                $('.leaflet-google-layer').remove(); //PERMET D'ÉLIMINER LA COUCHE GOOGLE QUI RESTE PRÉSENTE DANS LE DOM
            } // Ceci plante dans i.e. alors...
            catch (err) {
            }


        };

    }, 'Ouvrir la carte dans un autre navigateur web').addTo(map);


    //outil de dessin et ses parametres
    L.featureGroup().addTo(map);
    map.addControl(new L.Control.Draw({
        //options
        position: 'topleft',
        draw: { marker: false,
                circle: true,
                rectangle: true,
                polygon: {
                    allowIntersection: false,
                    showArea: true,
                    showLength: true
                },
                circlemarker: false},
        edit: false
    }));


    map.addControl(L.map.selectMultiple({
        map: map,
        activerSelectFeature: activerSelectFeature,
        url: '/gestion-roles/exp-ue/unite-evaluation-actualisation-inventaire.json/',
        selectedCallback: selectMultipleSelectedCallback,
        idMunicipalite: idMunicipalite,
        listeMatricule: $('#listeMatricule').val(),
        decocheUe: $('#decocheUe').val(),
        listeUe : $('#listeUe').val(),

    }));


    L.easyButton('fa-refresh', function () {
        refreshMap();
    }, 'Rafraichir la carte').addTo(map);


    // -----------------------------------------------------------------------
    //19365
    //-------------------------------------------------------------------------
    var listeMunicipaliteT = [];
    if ($('#listeMunicipalite').val()) {
        listeMunicipaliteT = JSON.parse($('#listeMunicipalite').val());
    }
    var listeMunicipalite = [];
    $.each(listeMunicipaliteT, function (idx, value) {
        listeMunicipalite.push(value['id_municipalite']);
    });
    if (jQuery.isArray(idMunicipalite)) {
        idMunicipalite = idMunicipalite[0];
    }
}

function getActiveLayersIds() {
    let checkedLayers = [];
    $(".ac-container").find('.menu-item-checkbox input[type=checkbox]').each(function () {
        if ($(this).prop('checked') && $(this).attr('id-map-layer')) {
            checkedLayers.push($(this).attr('id-map-layer'));
        }
    });
    return checkedLayers;
}


function refreshMap() {
    map.eachLayer(function (layer) {
        map.removeLayer(layer);
        map.addLayer(layer);
        //layer.redraw();
    });
}

var zoomClicked = true;

function triggerFirstHistorique(matricule) {
    if (matricule.length == 12) {
        matricule += '-000-0000';
    }

    var unitesEvaluation = $('#div-resultat-historique').find('.list-group-item');
    $.each(unitesEvaluation, function (idx, value) {
        var ueSelected = $(value).attr('id-matricule');
        if (ueSelected.length == 12) {
            ueSelected += '-000-0000';
        }

        if (matricule == ueSelected) {
            zoomClicked = false;
            $(value).trigger('click');
            return false;
        }

    });

}

function cleanExplorateurUe() {

    $('#exp-ue-body-information').empty();
    $('#exp-ue-body-photo-principale').empty();

    collapseAccordeonsExplorateurUe();
    detruireDatatablesExplorateurUe();
    viderAccordeonsExplorateurUe();
}

function collapseAccordeonsExplorateurUe() {
    if ($('#collapse-batiment').is(":visible")) $('#collapse-batiment').collapse('hide');
    if ($('#collapse-evenement').is(":visible")) $('#collapse-evenement').collapse('hide');
    if ($('#collapse-photos').is(":visible")) $('#collapse-photos').collapse('hide');
    if ($('#collapse-documents').is(":visible")) $('#collapse-documents').collapse('hide');
    if ($('#collapse-communication').is(":visible")) $('#collapse-communication').collapse('hide');
    if ($('#collapse-actif').is(":visible")) $('#collapse-actif').collapse('hide');
}

function viderAccordeonsExplorateurUe() {
    $('#exp-ue-body-batiment').empty();
    $('#exp-ue-body-evenement').empty();
    $('#exp-ue-body-photos-warning').empty();
    $('#div-photo').empty();
    $('#div-croquis').empty();
    $('#exp-ue-body-documents').empty();
    $('#exp-ue-body-communication').empty();
    $('#exp-ue-body-actifs').empty();
}

function detruireDatatablesExplorateurUe() {
    const table_actifs = $('#table-actifs');
    destroyDataTable(table_batiment);
    destroyDataTable(table_evenement);
    destroyDataTable(table_communication);
    destroyDataTable(table_document);
    destroyDataTable(table_actifs);
}

var expUEBoutons = {

    initEvenementsJQuery: function () {
    }
}; // namespace expUEBoutons

function findSig(idMunicipalite, idUe) {

    var params = {'idMunicipalite': idMunicipalite, 'idUe': idUe};
    var isSig;

    $.ajax({
        type: "GET",
        url: "/gestion-roles/tenue-a-jour/explorateur-ue/get-sig/",
        data: params,
        async: false,
        dataType: 'json',
        success: function (response) {
            isSig = response[0].response;
        }
    });
    return isSig;
}


function expUeGetCommunicationUe(idUe, idMunicipalite) {

    if ($('#exp-ue-body-communication').is(':empty')) {

        var params = {
            "id_municipalite": idMunicipalite,
            "id_ue": idUe
        };

        $.ajax({
            type: "POST",
            url: "/gestion-roles/exp-ue/communication/",
            data: params,
            dataType: 'html',
            success: function (response) {

                $('#exp-ue-body-communication').html(response);

                tableCommunication(idUe);

                $('button[name=btn-creer-communication]').off("click").on("click", function (a) {
                    editer_communication(a, null, null);
                });

            }
        });


    }
}

function is_auto_declaration(idMunicipalite) {

    var autoDeclaration;
    var params = {
        "id_municipalite": idMunicipalite
    };

    $.ajax({
        type: "GET",
        url: "/gestion-roles/exp-ue/auto-declaration/",
        data: params,
        async: false,
        dataType: 'json',
        success: function (response) {
            autoDeclaration = response[0].response;
        }
    });

    return autoDeclaration;

}


function tableCommunication(idUe) {
    var columnsDefJson = $('[name="hid-columns-def"]').val();
    var columnsDef = JSON.parse(columnsDefJson);

    for (var i = 0; i < columnsDef.length; i++) {
        if (columnsDef[i].render) {
            var runStr = columnsDef[i].render;
            columnsDef[i].render = new Function("data", "type", "row", runStr);
            /* {
             eval(runStr);
             }*/
        }
    }

    var columnsDefAsg = $.extend(true, {}, columnsDef);

    var table = $('#exp-ue-table-communication');
    table.find('tbody').remove();
    table_communication = initTableDatatable(table, {
        'serverSide': true,
        "searching": true,
        "bFilter": false,
        scrollX: true,
        sScrollXInner: "100%",
        "bInfo": false,
        "language": {
            "url": datatable_locale_url
        },

        "order": [[1, "desc"]],
        "ajax": {
            //"url": "/" + nameProject + "/alert/type/" + idInstrumentType + "/data.json/"
            "url": "/gestion-roles/exp-ue/json-communication/",
            "data": function (d) {
                d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                d.id_ue = idUe;
                d.colonnesDef = JSON.stringify(columnsDefAsg);
            },
            type: "POST"
        },
        "columnDefs": columnsDef,
        "preDrawCallback": function () {
            wait.start();
            return true;
        },

        "drawCallback": function () {
            wait.stop();
        }
    });

}

function chargerTaj() {
    const listeMunicipalite = JSON.parse($('#listeMunicipalite').val()).map(item => item.id_municipalite);
    const listeMatricule = JSON.parse($('#listeMatricule').val()).map(item => item.matricule);
    const unitesEvaluation = JSON.parse($('#listeUe').val());
    const dateEvenement = moment().format('YYYY-MM-DD');
    const bbox = {
        derniereDateFermetureCycle: dateEvenement,
        derniereDateFermetureGeomatique: dateEvenement,
        xmax: '-75.2583983263144',
        xmin: '-72.3930260161919',
        ymax: '44.9688409017251',
        ymin: '50.8478823529871'
    };

    setTimeout(() => {
        idMap = getInfoMap(listeMunicipalite[0], 31);
        expUeinitMap(listeMunicipalite, bbox, true, idMap, undefined, () => {
            map.selectFeatureTAJByAttribute(listeMatricule, true, true);
        });
    }, 100);


    unitesEvaluation.forEach(({id_ue, id_mun, matricule, adresse, date_evenement}) => {
        const historiqueDivString = getDivHistoriqueString(id_ue, id_mun, id_mun, matricule, adresse, date_evenement);
        $('#div-resultat-historique').prepend(historiqueDivString);
    });
    $('#div-resultat-historique-nb').text($('#div-resultat-historique').find('.list-group-item').length);
    if ($('#div-resultat-historique').find('.list-group-item').length > 0) {
        $('#btn-generer-pdf, #btn-exp-assigner-evenement').prop('disabled', false);
    }
}

function tableAssignerEvenementCallbackInit(){
    wait.stop();
    $('#adm-table-evenement-assigne_filter').parent().parent().find('div').first().prepend('<label class="position-relative margin-right-1 checkall-taj">\n' +
        '        <input class="ace" data-action="check-tj-select-all" name="check-tj-select-all" type="checkbox"\n' +
        '               title="Sélectionnez ou désélectionnez tous les évènements"\n' +
        '               aria-label="Sélectionnez ou désélectionnez tous les évènements">\n' +
        '        <span class="lbl">Sélectionner tout\n' +
        '                </span>\n' +
        '    </label>');
    let table = $('#adm-table-evenement-assigne');
    table.find('tbody').on('click', '.check-taj-assigne', function () {
        if ($(this).is(":checked")) {
            $(this).attr('checked', true);
        } else {
            $(this).attr('checked', false);
        }
    });
    table.parents('.modal').find('[name=check-tj-select-all]').off('click').on('click', function () {
        var elements_seleciones = table.find('input:checkbox[name=checkbox-assignation]');
        let bool_coche = $(this).is(":checked");
        $(elements_seleciones).each(function(e){
            $(this).prop('checked', bool_coche);
        });
    });
}
function tableAssignerEvenement(listeIdUe, layer, listeIdUeDateEvenement, autreCallback, listeIdEvenementNew=[]) {
    var table = $('#adm-table-evenement-assigne');
    table.find('tbody').remove();
    table.dataTable({
        'destroy': true,
        "scrollX": true,
        "searching": true,
        "aaSorting": [], // DÉFINITION DU TRI PAR DÉFAUT À L'OUVERTURE
        "bFilter": false,
        "lengthMenu": [[5,10, 25, 50, 100, -1], [5,10, 25, 50, 100, "Tous"]],
        "language": {
            "url": datatable_locale_url
        },

        "pageLength": 100,

        "ajax": {
            "url": "/gestion-roles/exp-ue/json-table-evenement-assigne/",
            "data": function (d) {
                d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                d.listeIdUe = JSON.stringify(listeIdUe);
                d.listeIdUeDateEvenement = JSON.stringify(listeIdUeDateEvenement);
                d.layer = JSON.stringify(layer);
            },
            type: "POST"
        },

        "columns": [
            {
                title: "",
                data: "id_evenement",
                width: '20px',
                // et c'est comme ça qu'on a des checbkbox dans la taj
                render: function (data, type, row) {
                    return '<div class="action-buttons-utiliser" id-evenement="' + data + '" class="choisir-mutation">' +
                        '<label class="position-relative">' +
                        '<input type="checkbox" class="ace check-taj-assigne" name="checkbox-assignation">' +
                        '<span class="lbl" title="Utiliser cet evenement"></span>' +
                        '</label>' +
                        '</div>';
                }
            },
            {"data": "evenement", "title": "Évenement"},
            {"data": "no_civique", "title": "No civique"},
            {"data": "voie_publique", "title": "Voie publique"},
            {"data": "id_ue", "title": "ID(UE)"},
            {"data": "assigner", "title": "Assignation"},
            {"data": "usage", "title": "Usage"},
            {"data": "etat", "title": "État"},
            {"data": "date_evenement", "title": "Date de prise d'effet au rôle"},
            {"data": "no_reference", "title": "No référence"},

        ],
        createdRow: function (row, data) {
            $(row).attr("data-id_evenement", data.id_evenement);
        },
        initComplete: function (settings, json) {
            tableAssignerEvenementCallbackInit();
            if(autreCallback){
                autreCallback(listeIdEvenementNew);
            }
        }
    });

}


function tablehistoriquelots(idUe, estsigweb2, bool_client_evaluation) {
    var table = $('#adm-table-historique-lots');
    table.find('tbody').remove();
    var groupColumn = 6;

    var url = "";
    if(bool_client_evaluation == true) {
        url = "/gestion-roles/exp-ue/json-table-historique-lots/" + idUe + "/";
    } else {
        // Si le client n'a pas le module d'évaluation, donc seulement SIG-Web 2,
        // prendre le ID UE "extranet"
        var idUe_sig = $('#idUe').val();
        url = "/georole_web_2/json-table-historique-lots/" + idUe_sig + "/";
    }

    initTableDatatable(table, {
        "scrollX": true,
        "scrollY": "400px",
        "responsive": false,
        "scrollCollapse": true,
        "searching": true,
        "bFilter": false,
        "bInfo": false,
        "language": {
            "url": datatable_locale_url
        },
        "bsortable": false,
        "paging": true,
        "pageLength": 25,
        "bsort": false,
        "ordering": false,

        "ajax": {
            "url": url,
            "data": function (d) {
                d.columns = []; //HACK TO REMOVE THE USELESS FILTER RELATED PARAMETERS
                d.id_ue = idUe;
                d.estsigweb2 = estsigweb2;
            },
            type: "POST"
        },
        "columns": [
            {"data": "no_lot", "title": "Numéro de Lot"},
            {"data": "suffixe", "title": "Suffixe"},
            {"data": "description", "title": "Description"},
            {"data": "designation", "title": "Désignation Secondaire"},
            {"data": "no_lot_nrenov", "title": "Numéro de Lot"},
            {"data": "partie", "title": "Partie"},
            {"data": "lignedate", "title": "event", className: "never", visible: false},

        ],
        rowGroup: {
            dataSrc: 'lignedate'
        },
        "drawCallback": function (settings) {
            var api = this.api();
            var rows = api.rows({page: 'current'}).nodes();
            var last = null;
            api.column(groupColumn, {page: 'current'}).data().each(function (group, i) {
                if (last !== group) {
                    $(rows).eq(i).before(
                        '<tr class="group"><td colspan="6">' + group + '</td></tr>'
                    );

                    last = group;
                }
            });
        },
        initComplete: function (settings, json) {
            wait.stop();
            var api = this.api();
            var tableId = $(this).attr('id');
            if (api.page.info().pages === 1) {
                $('#' + tableId + '_paginate').hide();
                $('#' + tableId + '_length').hide();
                $('#' + tableId + '_filter').hide();
            }
            $('#' + tableId + '_wrapper').find('.dataTables_scrollHead').find('thead').prepend("<tr role='row'><th colspan='3' class='text-center'>Cadastre du Québec</th>\n" +
                "           <th colspan='3' class='text-center'>Cadastre non rénové</th></tr>");
        }
    });

    table.find('tbody').on('click', 'tr.group', function () {
        var currentOrder = table.order()[0];
        if (currentOrder[0] === groupColumn && currentOrder[1] === 'asc') {
            table.order([groupColumn, 'desc']).draw();
        } else {
            table.order([groupColumn, 'asc']).draw();
        }
    });
}


function exp_ue_ouvrir_sommaire_cout(url_sommaire) {
    $.ajax({
        type: "GET",
        url: url_sommaire,
        success: function (response) {
            var modal_sommaire_cout = $("#modal_sommaire_cout");
            modal_sommaire_cout.find('.modal-body').html(response);
            modal_sommaire_cout.modal('show');
        }
    });
}

// Fonction pour recharger la carte dans un nouveau navigateur important de ne pas l'enlever merci
function rechargerCarteNewBrowser() {
    let listeMatricule = [],
        rawValue = $('#listeMatricule').val();
    // Essayer de parser le JSON du champ input caché/textarea
    if (rawValue !== "") {
        let listeMatriculeJSON = JSON.parse(rawValue);
        if (Array.isArray(listeMatriculeJSON)) {
            $.each(listeMatriculeJSON, function (idx, value) {
                if (value && typeof value.matricule !== "undefined") {
                    listeMatricule.push(value.matricule);
                } else if (typeof value === "string") {
                    listeMatricule.push(value);
                }
            });
            map.selectFeatureTAJByAttribute(listeMatricule, true, true);
        }
    } else {
        selectMultipleSelectedCallback(explorateur_selection_carte_layers);
    }
     if (window.activeMapLayerIds && window.activeMapLayerIds.length > 0) {
        setTimeout(function() {
            // Optimisation: chercher les checkboxes une seule fois
            const checkboxes = $(".ac-container").find('.menu-item-checkbox input[type=checkbox]');

            checkboxes.each(function () {
                const $checkbox = $(this);
                const idMapLayer = $checkbox.attr('id-map-layer');

                if (!idMapLayer) return; // Skip si pas d'id

                const shouldBeChecked = window.activeMapLayerIds.includes(idMapLayer);
                const isCurrentlyChecked = $checkbox.prop('checked');

                // Cliquer seulement si nécessaire
                if (shouldBeChecked !== isCurrentlyChecked) {
                    $checkbox.click();
                }
            });
        }, 1500);
    }
}



$(function () {
    /* On regroupe le id des deux boutons de l'explorateur, car ils ont le même comportement (ils sont séparés, car
    chaque élément a son ID distinct).
    */
    $(document).off('click', '#lien-exp-ue-modale-profil-evaluateur-responsable-actuel')
        .on('click', '#lien-exp-ue-modale-profil-evaluateur-responsable-actuel', function () {
            const url = $(this).data('url');
            init_modale_explorateur_profil_evaluateur_responsable(url)
        });
});

function init_modale_explorateur_profil_evaluateur_responsable(url) {
    setTimeout(function () {
        call_ajax(url, 'GET', undefined, function (response) {
            // On insère le contenu du body dans la modale
            $('#modale-exp-ue-profil-evaluateur-responsable .modal-body').html(response);
            // On initialise le select2
            $('#exp-ue-profil-evaluateur-responsable-list').select2();
            // On attache l'événement de clic au bouton de sauvegarde
            $('#btn-save-modal-exp-ue-profil-evaluateur-responsable').off('click').on('click',
                function (e) {
                    sauvegarde_modale_explorateur_profil_evaluateur_responsable(url);
                });
            $('#modale-exp-ue-profil-evaluateur-responsable').modal('show');
        });
    }, 0);
}

function sauvegarde_modale_explorateur_profil_evaluateur_responsable(url) {
    wait.start()
    let idProfilEvaluateur = $('#exp-ue-profil-evaluateur-responsable-list').val();
    let params = [
        {
            name: 'id_profil_evaluateur',
            value: idProfilEvaluateur
        }
    ];
    const jqxhr = $.ajax({
        url: url,
        async: false,
        type: 'POST',
        dataType: 'json',
        data: params,
    })

    jqxhr
        .done(function (xhr) {
                $('#modale-exp-ue-profil-evaluateur-responsable').modal('hide');
                $('#exp-ue-profil-evaluateur-responsable b').text(xhr.nouveau_profil)
                messageToastCompteur = 0;
                infos.ajouterMessageToast({
                    message: 'Sauvegarde réussie',
                    messageDuree: 500,
                    icone: 'fa-check-circle-o',
                    iconeCouleur: 'green'
                });
            }
        );
    jqxhr
        .fail(function (xhr) {
            if (xhr.responseJSON) {
                erreursAjax.afficherErreurGenerique('#exp-ue-profil-evaluateur-responsable-erreurs-generiques',
                    'append', '', xhr.responseJSON.message);
                messageToastCompteur = 0;
                infos.ajouterMessageToast({
                    message: "Erreur lors de la sauvegarde",
                    messageDuree: 2000,
                    icone: 'fa-times-circle-o',
                    iconeCouleur: 'red'
                });
            } else {
                erreursAjax.afficherErreurGenerique('#exp-ue-profil-evaluateur-responsable-erreurs-generiques',
                    'append', '', 'Une erreur s\'est produite. Si le problème persiste, veuillez contacter un administrateur.');
                messageToastCompteur = 0;
                infos.ajouterMessageToast({
                    message: 'Une erreur s\'est produite',
                    icone: 'fa-times-circle-o',
                    iconeCouleur: 'red',
                    messageDuree: 2000,
                    type: 'error'
                });
                wait.stop();
            }
        });
    wait.stop();
}

function selectMultipleSelectedCallback(response) {

    // #6124 permet de créer un array des éléments sélectionnée de la control layer
    var layer_true = []; // var layer = {type_evenement:'ACTUALISATION  ', type_batiment:'Résidentiel'};
    var layer_ids_liste = [];
    $(".ac-container").find('.menu-item-checkbox input[type=checkbox]').each(function () {
        if ($(this).prop('checked')) {
            var id = $(this).attr('id');
            //layer_true.push(layer)
            var idMapLayer = $(this).attr('id-map-layer');
            layer_ids_liste.push(idMapLayer);
            layer_true.push($(this).parent().find('label[for="' + id + '"]').text());
        }
    });

    ajouterfiltrelayer(layer_ids_liste);

    for (var i = 0; i < response.length; i++) {
        var idUe = response[i].properties.id_ue;
        var matricule = response[i].properties.matricule;
        var idMunicipalite = response[i].properties.id_municipalite;
        var adresse = response[i].properties.adresse;
        if (response[i].geometry === undefined) {
            response[i].geometry = response[i].properties.geometry;
        }
        ajouterHistorique(idUe, idMunicipalite, matricule, adresse);
        ajouterSelectionCarte(map, response[i].geometry, response[i].properties);
    }

    if (i > 0) {
        myProperties = response[0].properties;
    }
}

function getActifs() {
    const idUe = $('#exp-ue-body-information #id-ue').text();
    if (idUe) {
        wait.start();
        expUegetActifs(idUe);
    } else {
        $('#table-actifs').dataTable({
            "order": [],
            "columnDefs": [{
                "targets": 'no-sort',
                "orderable": false,
            }]
        });
        destroyDataTable(table_document);
        $('#exp-ue-body-actif').empty().append(getBanniereMessage('', "Sélectionner une unité d'évaluation"));
    }
}
